import React from 'react';
import { Link } from 'react-router-dom';

interface ButtonProps {
  text: string;
  to?: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset'; // Add type
}

const ButtonMore: React.FC<ButtonProps> = ({
  text,
  to,
  onClick,
  disabled = false,
  type = 'button',
}) => {
  if (to) {
    return (
      <Link to={to} className="button button-sec flex-row-align justify-center">
        {text}
      </Link>
    );
  }

  return (
    <button className="button button-sec" onClick={onClick} disabled={disabled} type={type}>
      {text}
    </button>
  );
};

export default ButtonMore;
